import React, { Fragment } from 'react';
import classnames from 'classnames';
import { Link } from 'formlabs-web-components/Link';
import { useTranslation } from 'react-i18next';

import './HeaderMenu.module.css';

const SiteSelector = ({
  open,
  sites,
  handleHoverSiteSelect,
  handleClickSiteSelect
}) => {
  const { t } = useTranslation();
  return (
    <div
      styleName="main-menu-item site-selector"
      onMouseEnter={handleHoverSiteSelect}
      onClick={handleClickSiteSelect}
      onKeyDown={handleClickSiteSelect}
      role="button"
      tabIndex="0"
    >
      <span styleName="top-level">
        {t('Dental')}
        <i
          className="fl-navigate_next"
          styleName={classnames({ show: open }, 'indicator')}
        />
      </span>
      <div styleName={classnames('invisible-padding', { show: open })}>
        <div styleName={classnames('mini-menu', { show: open })}>
          {sites.map(site => {
            const current =
              site.name.toLowerCase() === process.env.RAZZLE_CMS_SITE;
            return (
              <div styleName="site-link">
                {current ? (
                  <Fragment>
                    <p>
                      {site.name} <br />
                      <span styleName="url">{site.displayUrl}</span>
                    </p>
                    <p styleName="current">{t('Current')}</p>
                  </Fragment>
                ) : (
                  <Link to={site.url} target="_blank">
                    <p>
                      {site.name} <br />
                      <span styleName="url">{site.displayUrl}</span>
                    </p>
                    <p>
                      <i className="fl-external-link" />
                    </p>
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default SiteSelector;
